import { apiFetch, parseApiResponse } from '../../utils/apiClient';
import { careerFromApi, careerItemToApi, careerProfileToApi } from './models/rhModel';

const getUserValue = (user, ...keys) => {
  for (const key of keys) {
    if (user?.[key] !== undefined && user?.[key] !== null && user?.[key] !== '') {
      return user[key];
    }
  }

  return '';
};

export async function getCurrentUser() {
  const res = await apiFetch('/api/users/me');
  return parseApiResponse(res);
}

export async function modifyUser(payload) {
  const res = await apiFetch('/api/users/ModifyUser', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return parseApiResponse(res);
}

export async function changePassword(payload) {
  const res = await apiFetch('/api/users/ChangePassword', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return parseApiResponse(res);
}

export async function createAbsence(payload) {
  const res = await apiFetch('/api/rh/absences', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return parseApiResponse(res);
}

export async function getRHDashboard({ userId, view } = {}) {
  const params = new URLSearchParams();
  if (userId) params.set('userId', userId);
  if (view) params.set('view', view);
  const res = await apiFetch(`/api/rh/me${params.size ? `?${params}` : ''}`);
  return parseApiResponse(res);
}

export async function getRHAbsences() {
  const res = await apiFetch('/api/rh/absences');
  return parseApiResponse(res);
}

export async function getRHTrainings() {
  const res = await apiFetch('/api/rh/trainings');
  return parseApiResponse(res);
}

export async function requestRHTraining(payload) {
  const res = await apiFetch('/api/rh/trainings', { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function getRHContract() {
  const res = await apiFetch('/api/rh/contract');
  return parseApiResponse(res);
}

export async function getRHDocuments() {
  const res = await apiFetch('/api/rh/documents');
  return parseApiResponse(res);
}

export async function getRHCertifications() {
  const res = await apiFetch('/api/rh/certifications');
  return parseApiResponse(res);
}

export async function getRHOnboarding() {
  const res = await apiFetch('/api/rh/onboarding');
  return parseApiResponse(res);
}

export async function getRHCareerData(userId) {
  const res = await apiFetch(`/api/employee-profiles/${userId}/generation-data`);
  return parseApiResponse(res);
}

export async function getRHCareer() {
  const res = await apiFetch('/api/rh/me/career');
  return careerFromApi(await parseApiResponse(res));
}

export async function getRHSkillsCatalog() {
  const res = await apiFetch('/api/skills');
  return parseApiResponse(res);
}

export async function getRHSkillCategories() {
  const res = await apiFetch('/api/skills/categories');
  return parseApiResponse(res);
}

export async function getRHExpertiseDomains() {
  const res = await apiFetch('/api/expertise-domains');
  return parseApiResponse(res);
}

export async function proposeRHSkill(payload) {
  const res = await apiFetch('/api/skills/proposals', { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function getRHSkillProposals() {
  const res = await apiFetch('/api/skills/proposals');
  return parseApiResponse(res);
}

export async function reviewRHSkillProposal(id, status, comment = '') {
  const res = await apiFetch(`/api/skills/proposals/${id}`, { method: 'PATCH', body: JSON.stringify({ status, comment }) });
  return parseApiResponse(res);
}

export async function getRHDocumentTemplates(params = {}) {
  const query = new URLSearchParams(params);
  const res = await apiFetch(`/api/employee-profiles/templates${query.size ? `?${query}` : ''}`);
  return parseApiResponse(res);
}

export async function createRHDocumentTemplate(payload) {
  const res = await apiFetch('/api/employee-profiles/templates', { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function createRHDocumentTemplateVersion(id, payload = {}) {
  const res = await apiFetch(`/api/employee-profiles/templates/${id}/versions`, { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function setRHDocumentTemplateStatus(id, status) {
  const res = await apiFetch(`/api/employee-profiles/templates/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) });
  return parseApiResponse(res);
}

export async function getRHGenerationTemplates(documentType) {
  const params = new URLSearchParams(); if (documentType) params.set('type', documentType);
  const res = await apiFetch(`/api/rh/document-templates${params.size ? `?${params}` : ''}`);
  return parseApiResponse(res);
}

export async function previewRHDocument(payload) {
  const res = await apiFetch('/api/rh/me/documents/preview', { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function createRHDocumentDraft(payload) {
  const res = await apiFetch('/api/rh/me/documents', { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function updateRHDocumentDraft(id, payload) {
  const res = await apiFetch(`/api/rh/me/documents/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function generateRHDocumentDraft(id, payload = {}) {
  const res = await apiFetch(`/api/rh/me/documents/${id}/generate`, { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function getRHGeneratedDocuments() {
  const res = await apiFetch('/api/rh/me/documents');
  return parseApiResponse(res);
}

export async function duplicateRHGeneratedDocument(id) {
  const res = await apiFetch(`/api/rh/me/documents/${id}/duplicate`, { method: 'POST' });
  return parseApiResponse(res);
}

export async function archiveRHGeneratedDocument(id) {
  const res = await apiFetch(`/api/rh/me/documents/${id}/archive`, { method: 'PATCH' });
  return parseApiResponse(res);
}

export async function createRHCareerItem(resource, payload) {
  const res = await apiFetch(`/api/rh/me/career/${resource}`, { method: 'POST', body: JSON.stringify(careerItemToApi(resource, payload)) });
  return parseApiResponse(res);
}

export async function uploadRHReferenceImage(file) {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Impossible de lire l’image sélectionnée."));
    reader.readAsDataURL(file);
  });
  const res = await apiFetch('/api/rh/me/career/references/image', {
    method: 'POST',
    body: JSON.stringify({ dataUrl, fileName: file.name }),
  });
  return parseApiResponse(res);
}

export async function uploadRHProfilePhoto(file) {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Impossible de lire la photo sélectionnée."));
    reader.readAsDataURL(file);
  });
  const res = await apiFetch('/api/rh/me/career/profile/photo', {
    method: 'POST',
    body: JSON.stringify({ dataUrl, fileName: file.name }),
  });
  return parseApiResponse(res);
}

export async function updateRHCareerItem(resource, id, payload) {
  const res = await apiFetch(`/api/rh/me/career/${resource}/${id}`, { method: 'PUT', body: JSON.stringify(careerItemToApi(resource, payload)) });
  return parseApiResponse(res);
}

export async function deleteRHCareerItem(resource, id) {
  const res = await apiFetch(`/api/rh/me/career/${resource}/${id}`, { method: 'DELETE' });
  if (!res.ok) return parseApiResponse(res);
}

export async function duplicateRHCareerItem(resource, id) {
  const res = await apiFetch(`/api/rh/me/career/${resource}/${id}/duplicate`, { method: 'POST' });
  return parseApiResponse(res);
}

export async function reorderRHCareerItems(resource, ids) {
  const res = await apiFetch(`/api/rh/me/career/${resource}/reorder`, { method: 'PATCH', body: JSON.stringify({ ids }) });
  return parseApiResponse(res);
}

export async function generateRHCareerDocument(userId, payload) {
  const res = await apiFetch(`/api/employee-profiles/${userId}/generate`, { method: 'POST', body: JSON.stringify(payload) });
  return parseApiResponse(res);
}

export async function downloadRHCareerDocument(downloadUrl, fileName) {
  if (!downloadUrl) throw new Error('Le fichier généré ne possède pas d’adresse de téléchargement.');
  const res = await apiFetch(downloadUrl);
  if (!res.ok) return parseApiResponse(res);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'document.pdf';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Firefox peut annuler le téléchargement si l'URL Blob est révoquée
  // dans la même pile d'exécution que le clic.
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function previewRHCareerDocument(downloadUrl) {
  const res = await apiFetch(downloadUrl); if (!res.ok) return parseApiResponse(res);
  const blobUrl = URL.createObjectURL(await res.blob()); window.open(blobUrl, '_blank', 'noopener,noreferrer'); window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}

export async function uploadRHCareerEvidence(userId, resource, id, file) {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Impossible de lire le justificatif.'));
    reader.readAsDataURL(file);
  });
  const res = await apiFetch(`/api/employee-profiles/${userId}/${resource}/${id}/evidence`, {
    method: 'POST', body: JSON.stringify({ fileName: file.name, dataUrl }),
  });
  return parseApiResponse(res);
}

export async function verifyRHCareerItem(userId, resource, id, approved, options = {}) {
  const res = await apiFetch(`/api/employee-profiles/${userId}/${resource}/${id}/verification`, { method: 'POST', body: JSON.stringify({ approved, ...options }) });
  return parseApiResponse(res);
}

export async function updateRHProfessionalProfile(userId, payload) {
  const res = await apiFetch('/api/rh/me/career/profile', { method: 'PUT', body: JSON.stringify(careerProfileToApi(payload)) });
  return parseApiResponse(res);
}

export async function getAllEmployees() {
  const res = await apiFetch('/api/users/directory');
  const users = await parseApiResponse(res);

  return users.map((user) => ({
    ...user,
    name: [
      getUserValue(user, 'firstName', 'first_name'),
      getUserValue(user, 'lastName', 'last_name'),
    ].filter(Boolean).join(' '),
  }));
}


export async function getRHDirectoryProfile(userId) {
  const res = await apiFetch(`/api/rh/directory/${userId}`);
  const data = await parseApiResponse(res);
  return { ...data, career: careerFromApi(data.career) };
}


export async function getRHAbsenceRequests({ userId, status = 'pending' } = {}) {
  const params = new URLSearchParams({ status });
  if (userId) params.set('userId', userId);
  const res = await apiFetch(`/api/rh/absence-requests?${params}`);
  return parseApiResponse(res);
}

export async function decideRHAbsenceRequest(id, approved) {
  const res = await apiFetch(`/api/rh/absence-requests/${id}/decision`, { method: 'POST', body: JSON.stringify({ approved }) });
  return parseApiResponse(res);
}

export async function updateRHEmployment(userId, payload) {
  return parseApiResponse(await apiFetch(`/api/rh/directory/${userId}/employment`, { method: 'PUT', body: JSON.stringify(payload) }));
}
export async function uploadRHUserProfilePhoto(userId, file) {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Impossible de lire la photo sélectionnée.'));
    reader.readAsDataURL(file);
  });
  return parseApiResponse(await apiFetch(`/api/rh/directory/${userId}/photo`, { method: 'POST', body: JSON.stringify({ dataUrl }) }));
}

export async function getRHSkillTaxonomy() { return parseApiResponse(await apiFetch('/api/skills/taxonomy')); }

export async function reclassifyRHSkill(id, payload) { return parseApiResponse(await apiFetch(`/api/skills/${id}/classification`, { method: 'PATCH', body: JSON.stringify(payload) })); }
